import { InterfaceSettings } from '@/components/admin/beneficiary-app/InterfaceSettings'
import { defaultBeneficiaryAppSettings } from '@/components/helpers'
import { adminStoreActions } from '@/store/actions'
import { useStoreDispatch } from '@/store/hooks'
import { Organization } from '@/store/user'

export function BeneficiaryAppRoute({ organization }: { organization: Organization }) {
  const dispatch = useStoreDispatch()
  return (
    <InterfaceSettings
      organization={organization}
      handleAppSettings={{
        value: organization.chatSettings || defaultBeneficiaryAppSettings,
        onChange: (chatSettings) => {
          void dispatch(
            adminStoreActions.organization.update({
              fields: { chatSettings },
            }),
          )
        },
      }}
    />
  )
}
